<template>
  <div class="family">
    <Head :index="'2'"></Head>

    <div class="chartTop">
      <div><!-- 山东省莒县阎庄镇孙家山沟村孙其昌后裔族谱|孙其昌 <span> 共563人</span> --></div>
    </div>

    <div class="listDiv">
      <ul>
        <li v-for="(item, index) in tableData" :key="index">
          <div style="border: 0px;font-size: 25px;line-height:28px;text-align: center;margin-bottom: 20px">
            {{ item.name + "定位表" }}
          </div>
          <div style="border-top:2px solid #000;">
            <div>家族姓氏 <b></b></div>
            <span>{{ item.familyname!=null?item.familyname:'暂无' }}</span>
          </div>
          <div>
            <div>堂号 <b></b></div>
            <span>{{ item.tangnum!=null?item.tangnum:'暂无' }}</span>
          </div>
          <div>
            <div>始祖名讳 <b></b></div>
            <span>{{ item.ancestorname!=null?item.ancestorname:'暂无' }}</span>
          </div>
          <div>
            <div>民族 <b></b></div>
            <span>{{ item.mz!=null?item.mz:'暂无' }}</span>
          </div>
          <div>
            <div>本谱世系 <b></b></div>
            <span>{{ item.familytree!=null?item.familytree:'暂无' }}</span>
          </div>
          <div>
            <div>发源地 <b></b></div>
            <span>{{ item.fyzdydz!=null?item.fyzdydz:'暂无' }}</span>
          </div>
          <div>
            <div>起始年代 <b></b></div>
            <span>{{ item.fromyear!=null?item.fromyear:'暂无' }}</span>
          </div>
          <!-- beforefamilytree 上游谱中世系 -->
          <div>
            <div>家族简介 <b></b></div>
            <span>{{ item.intro!=null?item.intro:'暂无' }}</span>
          </div>
          <div>
            <div>操作 <b></b></div>
            <span style="padding:4px 10px 10px 10px">
              <el-button @click="viewClick(item)" size="small"
                v-if="item.id != familyId" style="padding:10px 7px">使用本家谱</el-button>
              <el-button @click="editClick(item)" type="primary" size="small" style="margin:10px 0 0 0;padding:10px 8px"
                v-if="item.canEdit">编辑</el-button>
              <el-button @click="delClick(item)" type="danger" size="small" style="margin:10px 0 0 0;padding:10px 8px"
                v-if="item.canDel">删除</el-button>
              <el-button @click="candelClick(item.id)" size="small" style="margin:10px 0 0 0;padding:10px 7px"
                v-if="item.canDel">权限设置</el-button>
           </span>
          </div>
        </li>
      </ul>
    </div>
    <div style="width: 1300px;margin:0 auto">
      <el-button type="primary" style="margin:10px" @click="addClick()">添加</el-button>
      <span>您可以建立一个小家谱定位表，限9代</span>
    </div>

    <el-dialog :visible.sync="dialogFamily" width="90%"><!-- 70% -->
            <span>
                <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="120px" label-position="left"
                         class="demo-ruleForm">
                    <el-form-item label="谱名" prop="name">
                      <el-input type="text" v-model="ruleForm.name" placeholder="请输入谱名"
                            autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="家族姓氏" prop="familyname">
                        <el-input type="text" v-model="ruleForm.familyname" placeholder="最大姓氏九个汉字"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="堂号" prop="tangnum">
                        <el-input type="text" v-model="ruleForm.tangnum" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="民族" prop="mz">
                        <el-select v-model="ruleForm.mz" placeholder="请选择民族" style="width:120px">
                            <el-option value="">请选择</el-option>
                            <el-option :value="item" v-for="item in $store.state.mzData" :key="item.index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="始祖名讳" prop="ancestorname">
                        <el-input type="text" v-model="ruleForm.ancestorname" autocomplete="off"
                                  placeholder="请填写全名"></el-input>
                    </el-form-item>
                    <el-form-item label="本谱世系" prop="familytree">
                        <el-input type="text" v-model="ruleForm.familytree" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="发源地" prop="befrom">
                        <!-- <el-input type="text" v-model="ruleForm.befrom" autocomplete="off"></el-input> -->
                        <Area
                          :propsinorout="ruleForm.fyinorout || 1"
                          :propssheng="ruleForm.fysheng"
                          :propsshi="ruleForm.fyshi"
                          :propsxian="ruleForm.fyxian"
                          :propszhen="ruleForm.fyzhen"
                          :propsdizhi="ruleForm.fyzdydz"
                          @area="areaFun"
                        ></Area>
                    </el-form-item>
                    <el-form-item label="起始年代" prop="fromyear">
                        <el-input type="text" v-model="ruleForm.fromyear" autocomplete="off"></el-input>
                    </el-form-item>
                  <!-- <el-form-item label="祖源地" prop="befrom">
                      <el-input @focus="mapOpen('coordinate')" v-model="ruleForm.coordinate"></el-input>
                  </el-form-item>
                  <el-form-item label="上游谱中世系" prop="beforefamilytree">
                      <el-input type="text" v-model="ruleForm.beforefamilytree" autocomplete="off"></el-input>
                  </el-form-item> -->
                    <el-form-item label="家族简介" prop="intro">
                        <el-input type="text" v-model="ruleForm.intro" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </span>
    </el-dialog>

    
    <el-dialog title="手机短信验证码" :visible.sync="moileDialog" width="90%">
      <span>
          <el-input prefix-icon="el-icon-menu" style="width: 54%;" type="text" v-model="phoneCode"
                    autocomplete="off"></el-input>
          <el-button type="primary" @click="getMobileCode()" style="margin-left: 10px">{{ codeMsg }}</el-button>
          <!-- <el-input prefix-icon="el-icon-menu" type="text" v-model="mobcode" autocomplete="off"></el-input> -->
        
          <el-input prefix-icon="el-icon-menu" style="width: 54%;margin-top:20px" type="text" v-model="oneCode"
                    autocomplete="off"></el-input>
          <img :src="sendmsgscr"  alt="" @click="captchaCode('delfamily')" style="vertical-align: top;margin-top:20px"/>
      </span>
      <template #footer>
        <span class="dialog-footer">
            <el-button type="primary" @click="delFun()">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="获取验证码" :visible.sync="dialogMobileCodeVisible" width="90%">
      <span>
         <el-input prefix-icon="el-icon-menu" style="width: 54%;margin-top:20px" type="text" v-model="code"
                    autocomplete="off"></el-input>
          <img :src="sendScr" alt="" @click="captchaCode('sendmsg')" style="vertical-align: top;margin-top:20px"/>
      </span>
      <template #footer>
        <span class="dialog-footer">
            <el-button type="primary" @click="getPhoneCode()">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="权限设置" :visible.sync="jurisdictionDialog" width="90%">
      <el-button @click="jurisdictionAddClick()" type="primary" size="small">添加</el-button>


     <!--  <table class="jurisdictionTable" border="1">
        <thead>
        <tr style="height:40px;">
          <th >用户手机</th>
          <th>姓名</th>
          <th>性别</th>
          <th>所在地</th> -->
          <!-- <th>手机号码</th> -->
         <!--  <th>权限</th>
          <th >祖先</th>
          <th>备注</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in jurisdictionTableData" :key="index">
          <td style="width:90px">{{ item.mobile }}</td>
          <td style="width:60px">{{ item.name }}</td>
          <td style="text-align: center;">{{ item.sex == 0 ? "男" : "女" }}</td>
          <td >{{ item.address }}</td> -->
          <!-- <td>{{ item.mobile }}</td> -->
         <!--  <td style="text-align: center;">
            <span v-if="item.level == 0">管理员</span>
            <span v-if="item.level == 1">分支管理员</span>
            <span v-if="item.level == 2">查看员</span>
          </td>
          <td>
            {{ item.mname }}
            <span v-if="item.shixu"> [{{ item.shixu }}世] 后裔 </span>
          </td>
          <td >{{ item.remarks }}</td> -->
         <!--  <td >
            <el-button @click="jurisdictionEditClick(item)" type="primary" size="small" style="margin:3px 0 3px 0;padding:8px">
              编辑
            </el-button>
            <el-button @click="jurisdictionDelClick(item)" type="danger" size="small" style="margin:3px 0 3px 0;padding:8px">删除
            </el-button>
          </td>
        </tr>
        </tbody>
      </table> -->
      <el-table :data="jurisdictionTableData" style="width: 100%">
          <el-table-column prop="mobile" label="用户手机" width="120"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center">
              <template slot-scope="scope">
                  <span v-if="scope.row.sex == 0">男</span>
                  <span v-if="scope.row.sex == 1">女</span>
              </template>
          </el-table-column>
          <el-table-column prop="address" label="所在地"> </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号码"> </el-table-column> -->
          <el-table-column prop="level" label="权限" align="center">
            <template slot-scope="scope">
                  <span v-if="scope.row.level == 0">管理员</span>
                  <span v-if="scope.row.level == 1">分支管理员</span>
                  <span v-if="scope.row.level == 2">查看员</span>
              </template>
          </el-table-column>
          <el-table-column prop="mname" label="祖先">
              <template slot-scope="scope">
                  {{ scope.row.mname }}
                  <span v-if="scope.row.shixu"> [{{ scope.row.shixu }}世] 后裔 </span>
              </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注"> </el-table-column>

          <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button @click="jurisdictionEditClick(scope.row)" type="primary" size="small" style="margin:3px 0 3px 0;padding:8px">
                  编辑
                </el-button>
                <el-button @click="jurisdictionDelClick(scope.row)" type="danger" size="small" style="margin:3px 0 3px 0;padding:8px">
                  删除
                </el-button>
              </template>
          </el-table-column>
      </el-table>
      <template #footer>
          <span class="dialog-footer">
              <el-button type="primary" @click="jurisdictionDialog = false">确定</el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="jurisdictionDialogFamily" width="90%">
            <span>
                <el-form :model="jurisdictionRuleForm" status-icon ref="ruleForm" label-width="90px"
                         label-position="left" class="demo-ruleForm">
                    <el-form-item label="ID" prop="id" style="display:none">
                        <el-input type="text" v-model="jurisdictionRuleForm.id" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input type="text" v-model="jurisdictionRuleForm.mobile" autocomplete="off"
                                  style="width:58%"></el-input>
                        <el-button type="primary" @click="searchbymobile()" style="margin-left: 10px">查找</el-button>
                    </el-form-item>
                    <div class="el-form-item el-form-item--feedback">
                        <label class="el-form-item__label" style="width: 90px;">姓名</label>
                        <div class="el-form-item__content" style="margin-left: 90px;">{{
                            jurisdictionRuleForm.name
                          }}</div>
                    </div>
                    <div class="el-form-item el-form-item--feedback">
                        <label class="el-form-item__label" style="width: 90px;">性别</label>
                        <div class="el-form-item__content" style="margin-left: 90px;">
                            {{ jurisdictionRuleForm.sex == 0 ? "男" : jurisdictionRuleForm.sex == 1 ? "女" : "" }}
                        </div>
                    </div>
                    <div class="el-form-item el-form-item--feedback">
                        <label class="el-form-item__label" style="width: 90px;">所在地</label>
                        <div class="el-form-item__content" style="margin-left: 90px;">{{
                            jurisdictionRuleForm.address
                          }}</div>
                    </div>
                    <el-form-item label="备注" prop="remarks">
                        <el-input type="text" v-model="jurisdictionRuleForm.remarks" autocomplete="off"
                                  style="width: 90%"></el-input>
                    </el-form-item>
                    <el-form-item label="分支祖先" prop="mid" v-if="jurisdictionRuleForm.level == 1">
                        <el-input type="text" v-model="jurisdictionRuleForm.xm" @focus="mTree()" autocomplete="off"
                                  style="width: 90%"></el-input>
                        {{ jurisdictionRuleForm.shixu }}
                      <!-- <treeSelect
                          :props="props"
                          :options="list"
                          :value="jurisdictionRuleForm.mid"
                          :clearable="isClearable"
                          :accordion="isAccordion"
                          @getValue="getValue($event)"
                      /> -->
                    </el-form-item>
                    <el-form-item label="等级" prop="level">
                        <!-- <el-input type="text" v-model="jurisdictionRuleForm.level" autocomplete="off"></el-input> -->
                        <el-radio v-model="jurisdictionRuleForm.level" :label="0">管理员</el-radio>
                        <el-radio v-model="jurisdictionRuleForm.level" :label="1">分支管理员</el-radio>
                        <el-radio v-model="jurisdictionRuleForm.level" :label="2">查看员</el-radio>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="jurisdictionSubmitForm()">确定</el-button>
                    </el-form-item>
                </el-form>
            </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogMap" width="90%" class="map">
      <vmap @getLnglat="getPosi"></vmap>
    </el-dialog>

    <el-dialog :visible.sync="dialogTree" width="90%" class="dialogTree">
      <el-tree
        :data="list"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :default-expand-all="true"
        :expand-on-click-node="false"
      ></el-tree>
    </el-dialog>
  </div>
</template>
<script>
import Head from "@/components/header.vue";
import orgtree from "@/components/orgtree.vue";
import vmap from "@/components/vmap.vue";
import treeSelect from "@/components/treeSelect.vue";
import Area from "@/components/area.vue";

import api from "@/request/api";

export default {
  data() {
    return {
      showType: false,
      dialogVisible: false,
      dialogMobileCodeVisible: false,
      moileDialog: false,
      dialogFamily: false,
      ruleForm: {
        name: "", // 谱名
        familyname: "", // 家族姓氏
        tangnum: "", // 堂号
        ancestorname: "", // 始祖名讳
        befrom: "", // 发源地
        familytree: "", // 本谱世系
        // beforefamilytree: "", // 上游谱中世系
        intro: "", // 家族简介
        fromyear:"",//起始年代
        coordinate: ""
      },
      type: "",

      tableData: [],
      mobcode: "",
      code: "",//点击获取手机验证码
      oneCode:"",//第一步的图形验证码
      phoneCode: "",
      countdown: 60,
      familyFid:'',//fid
      //按钮上的文字
      codeMsg: "获取验证码",
      mobileCode: "",
      //定时器
      timer: null,
      sendmsgscr: "",
      sendScr: "",
      dialogMap: false,
      maKkey: "",
      jurisdictionDialog: false,
      jurisdictionTableData: [],
      jurisdictionDialogFamily: false,
      jurisdictionFid: "",
      jurisdictionRuleForm: {
        id: "",
        mobile: "",
        mid: "",
        level: ""
      },
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props: {
        // 配置项（必选）
        value: "id",
        label: "xm",
        children: "children"
        // disabled:true
      },
      // 选项列表（必选）
      list: [],
      defaultProps: {
        children: "children",
        label: "xm"
      },
      dialogTree: false,
      familyId: ""
    };
  },
  mounted() {
    if (this.isMobile()) {
      // 手机端
      sessionStorage.setItem("flag", "app");
      this.flag = "app";
      // this.$router.push("/mobileguide");
    } else {
      // pc端
      sessionStorage.setItem("flag", "pc");
      this.flag = "pc";
    }
    this.getList();
  },
  methods: {
    searchbymobile() {
      if (this.jurisdictionRuleForm.mobile == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      api.selectbymobile(this.jurisdictionRuleForm.mobile).then((res) => {
        if (res.code == 0) {
          this.jurisdictionRuleForm.name = res.data.name;
          this.jurisdictionRuleForm.address = res.data.address;
          this.jurisdictionRuleForm.sex = res.data.sex;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    },
    getList() {
      api.familyList().then((res) => {
        if (res.code == 0) {
          this.tableData = res.data;
          res.data.forEach((index, item) => {
            if (res.data[item].isdefault == 1) {
              localStorage.setItem("fid", res.data[item].id);
            }
          });
          // if(!localStorage.getItem("fid")){
          //     localStorage.setItem("fid", res.data[0].id);
          // }
          //api.setDefaultFamily(res.data[0].id).then((res) => {});
          // api.getDefaultFamily().then((res) => {
          //     if (res.data) {
          //         this.familyId = res.data;
          //     } else {
          //         this.$message({
          //             message: "请先设置家谱!",
          //             type: "warning"
          //         });
          //     }
          // });
        }
      });
    },
    addClick() {
      this.dialogFamily = true;
      this.type = "add";
      this.ruleForm = {
        name: "", // 谱名
        familyname: "", // 家族姓氏
        tangnum: "", // 堂号
        ancestorname: "", // 始祖名讳
        befrom: "", // 发源地
        familytree: "", // 本谱世系
        // beforefamilytree: "", // 上游谱中世系
        intro: "", // 家族简介
        coordinate: ""
      };
    },
    submitForm() {
      if (this.type == "add") {
        api.familyAdd(this.ruleForm).then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.dialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      } else {
        api.familyEdit(this.ruleForm).then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$message({
              message: "修改成功"
            });
            this.dialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      }
    },
    mapOpen(key) {
      this.maKkey = key;
      this.dialogMap = true;
    },
    getPosi(lng, lat, address) {
      this.dialogMap = false;
      this.$set(this.ruleForm, this.maKkey, lng + ", " + lat);
    },
    delClick(row) {
      this.familyFid=row.id;
      this.phoneCode='';
      this.code='';
      this.oneCode='';
      api.familyDelFlag(row.id).then((res)=>{
        if (res.code == 0) {
          console.log(res.data,'---data')
          if(res.data==true){
             this.moileDialog = true;
             this.captchaCode('delfamily');
          }else{
            this.$message({
              message: "您非本家谱创始人，无法删除",
              type: "warning"
            });
            
          }
        }
      })
     
    },
    candelClick(id) {
      this.jurisdictionFid = id;
      this.jurisdictionDialog = true;
      api.permissionlist({fid: id}).then((res) => {
        if (res.code == 0) {
          this.jurisdictionTableData = res.data;
        }
      });
      api.listtreename({fid: id}).then((res) => {
        this.list = res.data;
      });
    },
    //验证码
    captchaCode(type){
      //type= delfamily   第一图片验证码
      console.log(type,'----type')
      if(type=='delfamily'){
        api.captcha(type).then((res) => {
          this.sendmsgscr = res.data;
        });
      }else if(type=='sendmsg'){
        api.captcha('sendmsg').then((res) => {
          this.sendScr = res.data;
        });
      }
    },
    getMobileCode() {
      // if (this.phone != "") {
        this.captchaCode('sendmsg')
        !this.timer ? (this.dialogMobileCodeVisible = true) : "";
      /* }  else {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
      } */
    },
    //获取短信验证码
    getPhoneCode() {
      if (!this.timer) {
        if(this.code==''){
          this.$message({
            message: "请输入图形验证码",
            type: "warning"
          });
        }else{
          let dataParams={
            fid: this.familyFid,
            type: 4,
            code: this.code
          }
          api.sendDelMsg(dataParams).then((res) => {
            if (res.code == 0) {
              this.setTime();
              setTimeout(() => {
                this.$message({
                    message: "发送成功",
                    type:'success'
                });
                this.dialogMobileCodeVisible = false;
              },500)
             
              
            } else {
              // this.$message({
              //   message: res.msg,
              //   type: "warning"
              // });
              this.captchaCode('sendmsg');
            }
        });
        }
      }
      // return false
      // api.familyDel({
      //   fid: 1,
      //   mobcode: this.mobcode,
      //   code: this.code
      // }).then((res) => {
      //   if (res.code == 0) {
      //     this.$message({
      //       message: "删除成功"
      //     });
      //     this.moileDialog = false;
      //   } else {
      //     this.$message({
      //       message: res.msg,
      //       type: "warning"
      //     });
      //     this.captcha();
      //   }
      // });
    },
     //倒计时
     setTime() {
        let _this = this;
        this.timer = setInterval(() => {
            if (_this.countdown > 0 && _this.countdown <= 60) {
                _this.countdown--;
                if (_this.countdown !== 0) {
                    _this.codeMsg = "重新发送(" + _this.countdown + ")";
                } else {
                    clearInterval(_this.timer);
                    _this.codeMsg = "获取验证码";
                    _this.countdown = 60;
                    _this.timer = null;
                }
            }
        }, 1000);
    },
    //确认删除
    delFun(){
      ///api/family/del?fid=家谱id&mobcode=短信验证码&code=图形验证码
      //familyDel
      let dataParams={
          fid: this.familyFid,
          mobcode: this.phoneCode,
          code: this.oneCode
      }
      if(this.phoneCode==''||this.oneCode==''){
        this.$message({
          message: "请填写信息",
          type: "warning"
        });
      }else{
        console.log(dataParams,'----------dataParams-')
        // return false
        api.familyDel(dataParams).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "删除成功"
          });
          this.captchaCode('delfamily');
          this.captchaCode('sendmsg');
          this.moileDialog = false;
          this.getList();
        } else {
          // this.$message({
          //   message: res.msg,
          //   type: "warning"
          // });
          this.captchaCode('delfamily');
        }
      });
      }
      // if(this.oneCode==''){
      //   this.$message({
      //     message: "请输入验证码",
      //     type: "warning"
      //   });
      // }

    },
    editClick(row) {
      this.dialogFamily = true;
      this.type = "eidt";
      this.ruleForm = {
        name: row.name, // 家族姓氏
        familyname: row.familyname, // 家族姓氏
        tangnum: row.tangnum, // 堂号
        ancestorname: row.ancestorname, // 始祖名讳
        befrom: row.befrom, // 发源地
        familytree: row.familytree, // 本谱世系
        beforefamilytree: row.beforefamilytree, // 上游谱中世系
        intro: row.intro, // 家族简介
        id: row.id,
        coordinate: row.coordinate,
        mz: row.mz,
        fydtdz: row.fydtdz,
        fysheng: row.fysheng,
        fyshi: row.fyshi,
        fyxian: row.fyxian,
        fyzdydz: row.fyzdydz
      };
    },
    viewClick(row) {
      api.familyGet(row.id).then((res) => {
        api.setDefaultFamily(res.data.id).then((res) => {
        });
        // this.$store.dispatch("getActionsData", { key: "fid", val: res.data.id });
        // this.$store.dispatch("getActionsData", { key: "fid", val: res.data.id });
        localStorage.setItem("fid", res.data.id);
        if(this.flag =='app'){
          this.$router.push("/mobilelineageChart");
        }else{
          this.$router.push("/lineageChart");
          }
      });
    },
    jurisdictionAddClick() {
      this.jurisdictionType = "add";
      this.jurisdictionDialogFamily = true;
      this.jurisdictionRuleForm = {
        id: "",
        mobile: "",
        mid: "",
        xm: "",
        name: "",
        address: "",
        shixu: "",
        remarks: "",
        level: 0
      };
    },
    jurisdictionEditClick(row) {
      this.jurisdictionType = "edit";
      this.jurisdictionDialogFamily = true;
      this.jurisdictionRuleForm = {
        id: row.id,
        mobile: row.mobile,
        xm: row.mname,
        mid: row.mid,
        sex: row.sex,
        address: row.address,
        name: row.name,
        shixu: row.shixu ? "[" + row.shixu + "世后裔]" : "",
        remarks: row.remarks,
        level: row.level
      };
    },
    jurisdictionDelClick(row) {
      this.$confirm("此操作将永久删除该权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'msgAlertBox',  
        type: "warning"
      })
        .then(() => {
          api.permissiondel({id: row.id}).then((res) => {
            if (res.code == 0) {
              this.candelClick(this.jurisdictionFid);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getValue(value) {
      // this.valueId = value;
      this.jurisdictionRuleForm.mid = value;
    },
    jurisdictionSubmitForm() {
      if (this.jurisdictionType == "add") {
        this.jurisdictionRuleForm.fid = this.jurisdictionFid;
        api.permissionadd(this.jurisdictionRuleForm).then((res) => {
          if (res.code == 0) {
            this.candelClick(this.jurisdictionFid);
            this.$message({
              message: "添加成功"
            });
            this.jurisdictionDialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      } else {
        api.permissionupdate(this.jurisdictionRuleForm).then((res) => {
          if (res.code == 0) {
            this.candelClick(this.jurisdictionFid);
            this.$message({
              message: "修改成功"
            });
            this.jurisdictionDialogFamily = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      }
    },
    areaFun(data) {
      this.$set(this.ruleForm, "fyinorout", data.inorout);
      this.$set(this.ruleForm, "fysheng", data.sheng);
      this.$set(this.ruleForm, "fyshi", data.shi);
      this.$set(this.ruleForm, "fyxian", data.xian);
      this.$set(this.ruleForm, "fyzhen", data.zhen);
      this.$set(this.ruleForm, "fyzdydz", data.dizhi);
      this.$set(this.ruleForm, "fydtdz", data.dtdz);
    },
    mTree() {
      this.dialogTree = true;
    },
    handleNodeClick(data) {
      this.dialogTree = false;
      this.jurisdictionRuleForm.mid = data.id;
      this.jurisdictionRuleForm.xm = data.xm;
      this.jurisdictionRuleForm.shixu = data.shixu ? data.shixu + "世后裔" : "";
    }
  },
  computed: {
    /* 转树形数据 */
    optionData() {
      // let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
      let cloneData = JSON.parse(
        JSON.stringify([
          {id: 1, parentId: 0, name: "一级菜单A", rank: 1},
          {id: 2, parentId: 0, name: "一级菜单B", rank: 1},
          {id: 3, parentId: 0, name: "一级菜单C", rank: 1},
          {id: 4, parentId: 1, name: "二级菜单A-A", rank: 2},
          {id: 5, parentId: 1, name: "二级菜单A-B", rank: 2},
          {id: 6, parentId: 2, name: "二级菜单B-A", rank: 2},
          {id: 7, parentId: 4, name: "三级菜单A-A-A", rank: 3},
          {id: 8, parentId: 7, name: "四级菜单A-A-A-A", rank: 4},
          {id: 9, parentId: 0, name: "一级菜单C", rank: 1},
          {id: 10, parentId: 0, name: "一级菜单end", rank: 1}
        ])
      );
      var data = cloneData.filter((father) => {
        // 循环所有项，并添加children属性
        let branchArr = cloneData.filter((child) => father.id == child.parentId); // 返回每一项的子级数组
        branchArr.length > 0 ? (father.children = branchArr) : ""; //给父级添加一个children属性，并赋值
        return father.parentId == 0; //返回第一层
      });
      return data;
    }
  },
  components: {
    Head,
    orgtree,
    vmap,
    treeSelect,
    Area
  }
};
</script>
<style>
  .msgAlertBox {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .msgAlertBox {
    width: 80% !important;
  }
}
</style>
<style lang="less" scoped>
.family {
  overflow: auto;

  .listDiv {
    > ul {
      width: 96%;
      margin: 0 auto;
      font-size: 16px;
      line-height: 20px;
      li {
        margin-top: 1rem;
        margin-bottom: 30px;
        border-bottom: 1px solid #000;
        width:99%;
        > div {
          border: 1px solid #000;
          border-left: 2px solid #000;
          border-right: 2px solid #000;
          border-bottom: 0;
          width: 100%;
          font-size: 0.9rem;
          div {
            width: 24%;
            height: 20px;
            padding: 10px 7px 0;
            margin-right: 0px;
            text-align: justify;
            display: inline-block;

            b {
              display: inline-block;
              padding-left: 100%;
            }
          }

          span {
            width: 74%;
            border-left: 1px solid #000;
            color: #000;
            text-align: left;
            padding:10px 10px;
          }

          .intro {
            text-align: left;
            text-indent: 32px;
            white-space: pre-wrap;
          }

          > * {
            display: inline-block;
            padding: 10px 20px;
            box-sizing: border-box;
            vertical-align: top;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/family.vue